import { Pipe, PipeTransform } from '@angular/core';
import { formatMillSecondsForAge } from '../utils/date.util';

@Pipe({
    name: 'ageFormat',
    pure: false
})
export class AgeFormatPipe implements PipeTransform {

    transform(date: Date, format: ('year' | 'month' | 'day' | 'hour' | 'minute' | 'second')): { value: number, i18n: string } {
        let value: number = formatMillSecondsForAge(date.valueOf())[format];
        let i18n: string;
        i18n = value >= 0 && value <= 1 ? 'date.' + format : 'date.' + format + 's';
        return {
            value,
            i18n
        };
    }
}